//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';
import {WhereTable,RestTypes as _RestTypes} from '../../lib/model-meta';

export class GeofenceRecord{
	public id:number;
	public vehicleId:string;
	public type:string;
	public muckpileId:number;
	public time:number;
	public isTagged:boolean=false;
}

export namespace GeofenceRecord{
	export const meta=new ModelMeta<keyof Props>(
		"GeofenceRecord",
		[],
		[
			{
				name: "id",
				type: "serial",
				decorators: {},
				uniqueKey: true,
				notNull: true
			},{
				name: "vehicleId",
				type: "string",
				decorators: {},
				notNull: true
			},{
				name: "type",
				type: "string",
				decorators: {},
				notNull: true
			},{
				name: "muckpileId",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "time",
				type: "number",
				decorators: {},
				notNull: true
			},{
				name: "isTagged",
				type: "boolean",
				decorators: {},
				default: false,
				optional: true,
				notNull: true
			}
		]
	);

	interface Props{
		id:number;
		vehicleId:string;
		type:string;
		muckpileId:number;
		time:number;
		isTagged?:boolean;
	}


	meta.generateRest("geofence-record",[
		{
			name: "email",
			type: "string",
			decorators: {}
		},{
			name: "authToken",
			type: "string",
			decorators: {}
		}
	]);

	export interface ReadableProps{
		id:number;
		vehicleId:string;
		type:string;
		muckpileId:number;
		time:number;
		isTagged?:boolean;
	}

	export interface ReadablePrimitiveProps{
		id:number;
		vehicleId:string;
		type:string;
		muckpileId:number;
		time:number;
		isTagged?:boolean;
	}

	namespace body{

		interface WritableProps{
			vehicleId:string;
			type:string;
			muckpileId:number;
			time:number;
			isTagged?:boolean;
		}

		export interface Auth{
			email?:string;
			authToken?:string;
		}

		export interface Get extends Auth{
			where:number;
			fields?:(keyof ReadableProps)[];
		}

		export interface Put extends Auth{
			where:number;
			fields:Partial<WritableProps>;
		}

		export interface Post extends Auth{
			fields:Partial<WritableProps>;
		}

		export interface Delete extends Auth{
			where:number;
		}

		export interface Count extends Auth{
			where?:WhereTable<keyof ReadablePrimitiveProps>;
		}

		export interface Search extends Auth{
			fields?:(keyof ReadablePrimitiveProps)[];
			where?:WhereTable<keyof ReadablePrimitiveProps>;
			range?:[number,number];
			sort?:Partial<Record<keyof ReadablePrimitiveProps,'+'|'-'>>;
		}
	}

	namespace _response{
		export type Get=Partial<ReadableProps>;
		export type Search=Partial<ReadablePrimitiveProps>[];
	}

	export interface RestTypes extends _RestTypes{
		body:{
			Auth:body.Auth;
			Get:body.Get;
			Put:body.Put;
			Post:body.Post;
			Delete:body.Delete;
			Count:body.Count;
			Search:body.Search;
		}

		response: {
			Get:_response.Get;
			Search:_response.Search;
		}
	}

}
